<template>
  <div class="row">
    <div class="col-12 mb-5">
      <h1>{{ emailDisplay }}</h1>
    </div>
    <div class="col-lg-4 dp04 p-3">
      <h3>{{ $t('userdetail.ChangePassword') }}</h3>
      <ValidationObserver ref="passwordObserver"
                          v-slot="{invalid}"
                          tag="form"
                          @submit.prevent="submitChangePass()">
        <ValidationProvider
          name="oldPass"
          ref="oldPass"
          rules="required"
          v-slot="{errors, classes}">
          <b-form-input type="password"
                        v-model="oldPass"
                        :class="{...classes, myInput: true}"
                        :placeholder="$t('common.OldPassword')" />
          <p class="myInputError">
            {{ errors[0] }}
          </p>
        </ValidationProvider>
        <ValidationProvider
          name="newPass"
          rules="required|password:newPassConfirmed"
          v-slot="{errors, classes}">
          <b-form-input type="password"
                        v-model="newPass"
                        :class="{...classes, myInput: true}"
                        :placeholder="$t('common.NewPassword')" />
          <p class="myInputError">
            {{ errors[0] }}
          </p>
        </ValidationProvider>
        <ValidationProvider
          name="newPassConfirmed"
          ref="newPassConfirmed"
          rules="required"
          v-slot="{errors, classes}">
          <b-form-input type="password"
                        v-model="newPassConfirm"
                        :class="{...classes, myInput: true}"
                        :placeholder="$t('common.NewPasswordConfirm')" />
          <p class="myInputError">
            {{ errors[0] }}
          </p>
        </ValidationProvider>
        <b-button
          type="submit"
          class="myButton align-middle">
          {{ $t("common.ChangePasswordConfirm") }}
        </b-button>
        <b-spinner
          v-if="passwordChangeRequestSent"
          variant="primary"
          class="align-middle ml-3"
          label="Spinning" />
      </ValidationObserver>
    </div>
    <div class="col-4 dp04 ml-1">
      <div class="row col-lg-12 p-3">
        <ValidationObserver ref="detailsObserver"
                            v-slot="{invalid}"
                            tag="form"
                            @submit.prevent="submitChangeDetails()">
          <h3>{{ $t('userdetail.ChangeDetails') }}</h3>
          <div class="col-12 row my-3">
            <div class="col-3">
              <label for="gender">{{ $t('common.PhoneNumber') }}:</label>
            </div>
            <div class="col-9">
              <ValidationProvider
                name="phoneNumber"
                rules="phone"
                v-slot="{errors, classes}">
                <b-form-input type="text"
                              v-model="phoneNumber"
                              :class="{...classes, myInput: true}" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="col-12 row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('common.Email') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                ref="emailField"
                name="email"
                rules="required|email"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="email" />
                <p class="myInputError mt-2">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="col-12 row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('common.Color') }}:</label>
            </div>
            <div class="col-lg-9">
              <ColorInput
                v-model="color" />
            </div>
          </div>
          <div class="col-12 row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('entities.Roles.Singular') }}:</label>
            </div>
            <div class="col-lg-9">
              <b-form-input
                class="myInput"
                :disabled="true"
                v-model="role" />
            </div>
          </div>
          <div class="col-12 row">
            <b-button
              type="submit"
              class="myButton align-middle">
              {{ $t("common.ChangeDetailsConfirm") }}
            </b-button>
            <b-spinner
              v-if="changeDetailsRequestSent"
              variant="primary"
              class="align-middle ml-3"
              label="Spinning" />
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapActions } from 'vuex';
import ColorInput from '@components/input/ColorInput';

export default {
  components: {
    ColorInput
  },
  data() {
    return {
      newPassConfirm: '',
      changeDetailsRequestSent: false,
      passwordChangeRequestSent: false,
      emailDisplay: ''
    };
  },
  mounted() {
    this.resetContext();
    this.fetchUser(this.$auth.user().id);
    this.phoneNumber = this.$auth.user().phoneNumber;
  },
  watch: {
    email(val) {
      if (this.emailDisplay === '') {
        this.emailDisplay = val;
      }
    }
  },
  computed: {
    oldPass: {
      get() {
        return this.$store.state.userDetail.oldPassword;
      },
      set(val) {
        this.setOldPassword(val);
      }
    },
    newPass: {
      get() {
        return this.$store.state.userDetail.newPassword;
      },
      set(val) {
        this.setNewPassword(val);
      }
    },
    email: {
      get() {
        return this.$store.state.userDetail.email;
      },
      set(val) {
        this.setEmail(val);
      }
    },
    color: {
      get() {
        return this.$store.state.userDetail.color;
      },
      set(val) {
        this.setColor(val);
      }
    },
    phoneNumber: {
      get() {
        return this.$store.state.userDetail.phoneNumber;
      },
      set(val) {
        this.setPhoneNumber(val);
      }
    },
    role: {
      get() {
        return this.$store.state.userDetail.role.name;
      }
    }
  },
  methods: {
    ...mapMutations({
      setOldPassword: 'userDetail/setOldPassword',
      setNewPassword: 'userDetail/setNewPassword',
      setUserId: 'userDetail/setUserId',
      setEmail: 'userDetail/setEmail',
      setColor: 'userDetail/setColor',
      setPhoneNumber: 'userDetail/setPhoneNumber',
    }),
    ...mapActions({
      changePassword: 'userDetail/changePassword',
      resetContext: 'userDetail/resetContext',
      fetchUser: 'userDetail/fetchUser',
      changeDetails: 'userDetail/changeDetails'
    }),
    async submitChangePass() {
      const isValid = await this.$refs.passwordObserver.validate();
      if (isValid) {
        this.passwordChangeRequestSent = true;
        this.changePassword()
          .then(() => {
            this.$root.$bvToast.toast(this.$t('common.PasswordResetToastSuccess.Body'), {
              title: this.$t('common.PasswordResetToastSuccess.Title'),
              variant: 'success',
              toaster: 'b-toaster-top-right'
            });
            this.oldPass = '';
            this.newPass = '';
            this.newPassConfirm = '';
            this.$refs.passwordObserver.reset();
          })
          .catch((error) => {
            if (error.status === 400) {
              this.$refs.oldPass.setErrors([this.$t('userdetail.OldPasswordWrong')]);
            }

            this.$root.$bvToast.toast(this.$t('common.PasswordResetToastFailure.Body'), {
              title: this.$t('common.PasswordResetToastFailure.Title'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
          })
          .finally(() => {
            this.passwordChangeRequestSent = false;
          });
      }
    },
    async submitChangeDetails() {
      const isValid = await this.$refs.detailsObserver.validate();
      if (isValid) {
        this.changeDetailsRequestSent = true;
        this.changeDetails()
          .then(() => {
            this.$root.$bvToast.toast(this.$t('userdetail.ChangeDetailsToastSuccess.Body'), {
              title: this.$t('userdetail.ChangeDetailsToastSuccess.Title'),
              variant: 'success',
              toaster: 'b-toaster-top-right'
            });
            this.$auth.fetchUser();
            this.emailDisplay = this.email;
          })
          .catch((error) => {
            if (error.status === 409) {
              this.$refs.emailField.setErrors([this.$t('userdetail.DuplicateEmail')]);
            }
            this.$root.$bvToast.toast(this.$t('userdetail.ChangeDetailsToastFailure.Body'), {
              title: this.$t('userdetail.ChangeDetailsToastFailure.Title'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
          })
          .finally(() => {
            this.changeDetailsRequestSent = false;
          });
      }
    }
  }
};
</script>
<style lang="scss"></style>
